import { Host, h } from "@stencil/core";
export class ChTimer {
    constructor() {
        this.progress = 0;
        this.accessibleName = "timer";
        this.animationTime = 0;
        this.presented = false;
    }
    render() {
        const accessibilityAttributes = {
            role: "timer",
            "aria-live": "true",
            "aria-labelledby": this.accessibleName,
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            "aria-valuenow": this.progress
        };
        return (h(Host, { key: '23456c3847d2ce033d2d6ca4cd1704c267569535' }, this.presented && this.progress >= 0 && (h("div", { key: 'e08b0f80d0612e0193d961e8190b3de3db0ee379', ...accessibilityAttributes, part: "indicator", class: "indicator", style: {
                "--animation-time": `${this.animationTime}ms`
            } }))));
    }
    static get is() { return "ch-timer"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["timer.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["timer.css"]
        };
    }
    static get properties() {
        return {
            "progress": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the progress propiety to determine the progress."
                },
                "attribute": "progress",
                "reflect": false,
                "defaultValue": "0"
            },
            "accessibleName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the accesible name of the timer."
                },
                "attribute": "accessible-name",
                "reflect": false,
                "defaultValue": "\"timer\""
            },
            "animationTime": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the animationTime to set the custom var for the css animation."
                },
                "attribute": "animation-time",
                "reflect": false,
                "defaultValue": "0"
            },
            "presented": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the presented property to handle the component presentation."
                },
                "attribute": "presented",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
